import { render, staticRenderFns } from "./intellidataDevice.vue?vue&type=template&id=fb2caece&scoped=true"
import script from "./intellidataDevice.vue?vue&type=script&lang=js"
export * from "./intellidataDevice.vue?vue&type=script&lang=js"
import style0 from "./intellidataDevice.vue?vue&type=style&index=0&id=fb2caece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2caece",
  null
  
)

export default component.exports